"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfig = getConfig;
const environment_1 = require("@krauters/environment");
const structures_1 = require("@krauters/structures");
const os_1 = require("os");
const structures_2 = require("./structures");
const utils_1 = require("./utils");
function getConfig(options) {
    return environment_1.EnvironmentBuilder.create('CODENAME', 'ENV', 'HOST', 'LOG_FORMAT', 'LOG_LEVEL', 'LOG_PREFIX', 'LOG_SECTION_SEPARATOR', 'PACKAGE', 'SIMPLE_LOGS', 'STAGE', 'TIMESTAMP_FORMAT', 'VERSION')
        .optionals('REQUEST_ID', 'LOG_FRIENDLY_FIELDS_HIDE', 'LOG_STRUCTURED_FIELDS_HIDE')
        .transform((value) => !(0, utils_1.isFalsy)(value), 'SIMPLE_LOGS')
        .transform((value) => (value.trim() === '' ? [] : value.replace(/\s/g, '').split(',')), 'LOG_FRIENDLY_FIELDS_HIDE', 'LOG_STRUCTURED_FIELDS_HIDE')
        .transform((value) => value, 'ENV')
        .transform((value) => value, 'STAGE')
        .transform((value) => value, 'LOG_LEVEL')
        .defaults({
        CODENAME: structures_2.empty,
        ENV: structures_1.Env.Unknown,
        HOST: (0, os_1.hostname)(),
        LOG_FORMAT: 'friendly',
        LOG_LEVEL: structures_2.LogLevel.Info,
        LOG_PREFIX: '',
        LOG_SECTION_SEPARATOR: ' | ',
        PACKAGE: structures_2.empty,
        SIMPLE_LOGS: false,
        STAGE: structures_1.Stage.Unknown,
        TIMESTAMP_FORMAT: 'YYYY-MM-DD HH:mm:ssZ',
        VERSION: structures_2.empty,
        ...options,
    })
        .withPrefix(options?.ENVIRONMENT_PREFIX ?? '')
        .environment();
}
//# sourceMappingURL=config.js.map